export function determineInitialMarkdown(markdownPersistedToBackend, defaultTemplate, unsavedNote) {
    // if there are unsaved changes, show them in the editor
    if (typeof unsavedNote === 'string') {
        return unsavedNote;
    }
    // if there are no unsaved changes, but there is persisted content,
    //    use it
    if (markdownPersistedToBackend) {
        return markdownPersistedToBackend;
    }
    // if there is no unsaved changes and no persisted content, use the default
    //     template if it doesn't exist
    if (defaultTemplate) {
        return defaultTemplate;
    }
    // fallback to empty string if none of the above are present
    return '';
}
//# sourceMappingURL=determine_initial_markdown.js.map